import { deviceInfo, loginDeviceSource } from "types/auth/login.types"

export const getLoginInfo = async (window: Window, type: string): Promise<deviceInfo> => {
    return {
        device: window.navigator.userAgent,
        source: type === 'GOOGLE' ? loginDeviceSource.GOOGLE_AUTH_APPLICATION : loginDeviceSource.ALEXA_AUTH_APPLICATION
    }
}